import React from "react";
import BudgetEntriesPage from "@/pages/BudgetEntriesPage";

export default function BudgetIncomeDefinitions() {
  return (
    <BudgetEntriesPage
      kind="gelir"
      title="Gelir Kayıtları"
      subtitle="Bütçe Yönetimi"
      testIdPrefix="income"
    />
  );
}
